(function() {

	$('.giant').find('span').on('click', function() {
		var href = $('.giant a').attr('href');
		window.open(href);
	});

})();